<template>
  <div v-if="margin">{{ renderRemark(address) }}</div>
  <span v-else>{{ renderRemark(address) }}</span>
</template>
<style scoped>
span {
  white-space: pre-wrap;
}
div {
  white-space: pre-wrap;
  margin-left: 16px;
}
</style>

<script>
export default {
  name: "DisplayPlannerRemark",
  props: ["address", "margin"],
  methods: {
    renderRemark(text) {
      if (text) {
        if (text.remarkPlanner) {
          return text.remarkPlanner;
        }
      }
      return "";
    }
  }
}
</script>
